import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Company } from "../Types/companyTypes";

export const companiesApi = createGenericApiSlice<Company>({
	reducerPath: "companiesApi",
	tag: TagTypes.Company,
	endpoint: "companies",
});

export const {
	useGetAllQuery: useGetCompaniesQuery,
	useGetByIdQuery: useGetCompanyByIdQuery,
	useCreateMutation: useCreateCompanyMutation,
	useUpdateMutation: useUpdateCompanyMutation,
	useDeleteMutation: useDeleteCompanyMutation,
} = companiesApi;
